import { useState } from 'react';
import { DateRange } from '../../components';
import { useTranslation } from 'react-i18next';

interface IDateRangesBlock {
  onChange: (year: string, quarter: number) => void;
  year?: string;
  quarter?: number;
}

export const Quarters = [
  'Q1: january-march',
  'Q2: april-june',
  'Q3: july-september',
  'Q4: october-december',
];

const DateRangesBlock = ({ onChange, year, quarter }: IDateRangesBlock) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const [currentQuarter, setCurrentQuarter] = useState<number>(quarter);
  const [newYear, setNewYear] = useState<string>(year ? year : currentYear.toString());

  const getRelevantYears = (): string[] => {
    return [currentYear - 1, currentYear, currentYear + 1].map((item) => item.toString());
  };

  return (
    <>
      <DateRange
        title={t('years')}
        items={getRelevantYears()}
        value={newYear}
        onChange={(e) => {
          onChange(e.target.value, currentQuarter);
          setNewYear(e.target.value);
        }}
      />
      <DateRange
        title={t('quarter')}
        items={Quarters}
        value={Quarters[currentQuarter]}
        onChange={(e) => {
          onChange(newYear, Quarters.indexOf(e.target.value));
          setCurrentQuarter(Quarters.indexOf(e.target.value));
        }}
      />
    </>
  );
};

export default DateRangesBlock;
